export default store => {
  return store.subscribe(mutation => {
    switch (mutation.type) {
      case "rules/setRules": {
        window.Vue.prototype.$ability.update(store.state.rules.rules);
        break;
      }
    }
  });
};
